module.exports = __webpack_public_path__ + "static/media/btn-readmore-red.d2e5fbcd.svg";